import { IFramePlayer } from 'iframe/ts/player/IFramePlayer';
import $ from 'jquery';
import { setupPlayerServicesNamespace } from 'library/ts/namespaces/PlayerServices';
window.$ = $;
setupPlayerServicesNamespace()
    .then((namespace) => {
    window.IFramePlayer = window.IFramePlayer || new IFramePlayer(namespace);
});
